module.exports = __webpack_public_path__ + "img/6107a050cf80c6.96918656.55fa4f6b.png";